import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页", end: true },
  { to: "/section/zongmen", label: "宗门篇剧情" },
  { to: "/section/jingjie", label: "修炼境界" },
  { to: "/section/zhuxian", label: "主线剧情" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`sticky top-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? "border-background-200/80 bg-background-50/90 backdrop-blur"
          : "border-transparent bg-background-50"
      }`}
    >
      <div className="container-x flex h-16 items-center justify-between md:h-[72px]">
        <Link to="/" className="flex items-center gap-2.5 whitespace-nowrap" aria-label="师兄啊师兄讨论区 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-sword-line text-lg"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-ink text-xl text-primary-700">师兄啊师兄</span>
            <span className="mt-0.5 text-[11px] tracking-widest text-foreground-400">剧情讨论区</span>
          </span>
        </Link>

        <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) =>
                `rounded-full px-4 py-2 text-sm transition-colors whitespace-nowrap ${
                  isActive
                    ? "bg-primary-50 font-medium text-primary-700"
                    : "text-foreground-600 hover:bg-background-100 hover:text-primary-700"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center md:flex">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-chat-3-line text-base"></i>
            留言讨论
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-lg text-foreground-700 hover:bg-background-100 md:hidden"
          aria-label={open ? "关闭菜单" : "打开菜单"}
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-2xl`}></i>
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                className={({ isActive }) =>
                  `rounded-lg px-3 py-2.5 text-sm transition-colors ${
                    isActive ? "bg-primary-50 font-medium text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/contact"
              className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-chat-3-line text-base"></i>
              留言讨论
            </Link>
          </div>
        </nav>
      )}
    </header>
  );
}